import * as React from "react"

const IntegrationMarketplaceHeader = ({
  iconColour,
  image,
  title,
  description,
  marketplaceButtonText,
  marketplaceButtonOnClick,
  marketplaceButtonLabel,
  marketplaceButtonLoading,
  supportButtonText,
  supportButtonUrl,
  supportButtonLabel,
}) => {
  return (
    <div className="integration-page-header-container mb-10 middle-xs center-xs">
      <div className="integration-page-header col-lg-7 start-xs middle-xs">
        <div
          className={`integration-page-header__logo ${
            iconColour === "ffffff"
              ? "integration-page-header__logo--border"
              : ""
          }`}
          style={{ background: `#${iconColour}` }}
        >
          <img
            src={`/icons/integrations/${image}`}
            className="integration__image"
            alt={`${title}`}
          />
        </div>
        <span>
          <h1 className="mb-0 h4 integration-page-header__title">{title}</h1>
          <p className="p--sm">{description}</p>
        </span>
      </div>
      <div className="integration-page-header__buttons">
        <div className="integration-page-header__button--marketplace">
          <button
            onClick={marketplaceButtonOnClick}
            className="integration-page-header__button btn btn--tertiary"
          >
            {!marketplaceButtonLoading ? (
              marketplaceButtonText
            ) : (
              <div className="loading-spinner">
                <span className="loading-spinner__spinner"></span>
              </div>
            )}
          </button>
          <p className="p--xs">{marketplaceButtonLabel}</p>
        </div>
        <div className="integration-page-header__button--marketplace">
          <a
            href={`${supportButtonUrl}`}
            className="integration-page-header__button btn btn--lg "
          >
            {supportButtonText}
          </a>
          <p className="p--xs">{supportButtonLabel}</p>
        </div>
      </div>
    </div>
  )
}

export default IntegrationMarketplaceHeader
